import Highlight from '@components/payment/BuyOfferHighlight'
import isTempUser from '@utils/user/isTempUser'

const withOfferHighlight =
    (TargetComponent) =>
        (props) => {
            const { highlight, user } = props
            const shouldDisplay = !isTempUser(user) && Boolean(highlight)

            return (
                <>
                    <Highlight highlight={highlight} user={user} shouldDisplay={shouldDisplay} />
                    <TargetComponent {...props} />
                </>
            )
        }

export default withOfferHighlight